import axios from 'axios'
import qs from 'qs'
import url from './url'
import sign from '@/auth/sign'
import vm from '../main'

const ajax = axios.create({
  baseURL: url.wz,
  timeout: 1000 * 12
})

/**
 * 请求拦截
 */
ajax.interceptors.request.use(
  config => {
    config.method = config.method || 'get'

    let headers = {}
    if (config.method === 'post') {
      headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    if (
      (config.params && config.params.withToken) ||
      (config.data && config.data.withToken)
    ) {
      headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    }
    config.headers = headers
    if (config.method === 'post') {
      config.data = config.data || {}
      if (config.data.withToken) {
        delete config.data.withToken
      }
      for (var k in config.data) {
        if (config.data[k] === undefined) {
          delete config.data[k]
        }
      }
      config.data['appid'] = 'wzwebapp'
      config.data['timestamp'] =  parseInt(new Date().getTime() / 1000)
      config.data['sign'] = sign(config.data)
      config.data = qs.stringify(config.data)
    } else {
      config.params = config.params || {}
      if (config.params.withToken) {
        delete config.params.withToken
      }
      for (var k2 in config.params) {
        if (config.params[k2] === undefined) {
          delete config.params[k2]
        }
      }
      config.params['appid'] = 'wzwebapp'
      config.params['timestamp'] =  parseInt(new Date().getTime() / 1000)
      config.params['sign'] = sign(config.params)
    }
    return config
  },
  error => Promise.resolve(error)
)

/**
 * 响应拦截
 */
ajax.interceptors.response.use(
  // 请求成功
  res => {
    if (res && res.data && res.data.newtoken) {
      localStorage.setItem('token', res.data.newtoken)
    }
    if (res.data.code === 200) {
      return Promise.resolve(res)
    } else if (res.data.code === 101) {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      vm.$message({
        type: 'error',
        message: '登陆状态已失效，请重新登录'
      })
      vm.$router.push({
        name: 'Login'
      })
    } else {
      return Promise.reject(res)
    }
  },
  // 请求失败
  error => {
    const { response } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      return Promise.reject(response)
    } else {
      return Promise.reject(error)
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
    }
  }
)

export default ajax



// WEBPACK FOOTER //
// ./src/axios/ajax.js